// MAP-03 事件地圖：地圖 / 平面圖上要打點的事件。來源兩種——即時 / 最近事件（useRecentEvents），或事件頁帶過來的搜尋結果（pins）。

export interface MapEventPin {
  /** <home_id>/<aid 或 aid:chN> */
  deviceKey: string;
  ts: number;
  eventId: string;
  homeId: string;
  type: string;
  /** 分級（alarm / detection …）：地圖「只看警報」用；沒有就依事件 class 推 */
  level?: string;
}

export const MAX_MAP_PINS = 200;

/** 依設備彙整（每台最新的時間、筆數），給標記上色與計數。 */
export function pinsByDevice(pins: MapEventPin[]): Map<string, { ts: number; count: number }> {
  const out = new Map<string, { ts: number; count: number }>();
  for (const p of pins) {
    const cur = out.get(p.deviceKey);
    if (!cur) out.set(p.deviceKey, { ts: p.ts, count: 1 });
    else out.set(p.deviceKey, { ts: Math.max(cur.ts, p.ts), count: cur.count + 1 });
  }
  return out;
}

/** 導頁帶來的 state 是外部資料：只收形狀對的、最多 MAX_MAP_PINS 筆。 */
export function parsePins(state: unknown): MapEventPin[] {
  const list = (state as { pins?: unknown } | null)?.pins;
  if (!Array.isArray(list)) return [];
  const out: MapEventPin[] = [];
  for (const x of list) {
    const p = x as Partial<MapEventPin>;
    if (typeof p?.deviceKey === 'string' && typeof p.ts === 'number' && typeof p.eventId === 'string' && typeof p.homeId === 'string')
      out.push({ deviceKey: p.deviceKey, ts: p.ts, eventId: p.eventId, homeId: p.homeId, type: typeof p.type === 'string' ? p.type : '', ...(typeof p.level === 'string' ? { level: p.level } : {}) });
    if (out.length >= MAX_MAP_PINS) break;
  }
  return out;
}
